// Lib
import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

// Components
import OrderProductDetails from '../../../Modals/OrderProductDetails/OrderProductDetails';

// Hooks
import useUser from '../../../../../hooks/useUser';
import useUI from '../../../../../hooks/useUI';
import useUnavailableForOrderProduct from '../../../../../hooks/useUnavailableForOrderProduct';

// Actions
import { OpenModal } from '../../../../../actions/modal';

// Utils
import getRemainingQuantity from '../../../../../utils/getRemainigQuantity';
import { getLimits } from '../../../../../utils/overLimit';
import { getProductTotalItemsOrdered } from '../../../../../pages/OrderHistory/utils/getQuantity';

// Styles
import { useStyles } from './ListContentStyles';

const getPiRequiredText = (prepack_quantity, pi_required) => {
  if (!prepack_quantity) {
    return 'N/A';
  }
  return pi_required ? 'Yes' : 'No';
};

const useListContent = ({
  product,
  order,
  orderItem,
  isRecurring,
  addressesCount,
}) => {
  const { order_limit, pi_required, prepack_quantity, limits } = product || {};

  const { isUnavailableForOrder, unavailableLabel } =
    useUnavailableForOrderProduct(product);

  const { monthLimit } = useMemo(() => getLimits(limits), [limits]);

  const remainingMonthQuantity = useMemo(
    () => getRemainingQuantity(monthLimit),
    [monthLimit],
  );

  const { isDesktopMode, isMobileMode, isTabletMode } = useUI();

  const dispatch = useDispatch();
  const { isKiteUser } = useUser();
  const { classes, cx } = useStyles({
    isKiteUser,
    order_limit,
    isDesktopMode,
    isMobileMode,
    isTabletMode,
  });

  const onOpenModal = useCallback(() => {
    dispatch(
      OpenModal({
        Component: OrderProductDetails,
        props: {
          productId: product.product_id,
          isFullScreen: isTabletMode,
          order,
          orderItem,
          addressesCount,
          isRecurring,
          paddingContent: {
            xl: '50px 40px 50px',
            lg: '60px 28px 30px',
            md: '40px 12px 16px',
          },
        },
        styles: {
          width: 'min(90vw, 1143px)',
        },
      }),
    );
  }, [
    dispatch,
    product,
    order,
    isTabletMode,
    orderItem,
    addressesCount,
    isRecurring,
  ]);

  const totalOrdered = useMemo(
    () => getProductTotalItemsOrdered(product, orderItem, addressesCount),
    [product, orderItem, addressesCount],
  );

  return {
    isUnavailableForOrder,
    unavailableLabel,
    remainingMonthQuantity,
    isDesktopMode,
    isMobileMode,
    isTabletMode,
    classes,
    cx,
    onOpenModal,
    totalOrdered,
    piRequiredText: getPiRequiredText(prepack_quantity, pi_required),
  };
};

export default useListContent;
